// import Seo from '@/components/Seo/Seo'
import UserWrapper from "../../../layout/userwrapper/UserWrapper";
import {
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
// import Image from 'next/image'
import { Link } from "react-router-dom";
import React from "react";
import styles from "../../../styles/pages/user/content-buyer-dashboard.module.scss";
import assest from "../../../json/assest";
import NextArrowIcon from "../../../ui/Icons/NextArrowIcon";
import ForwardIcon from "../../../ui/Icons/ForwardIcon";
import VideoUrlCard, {
  urlCardProps,
} from "../../../components/VideoUrlCard/VideoUrlCard";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import VideosummaryCard from "../../../components/VideosummaryCard/VideosummaryCard";
import PurchaseVdoIcon from "../../../ui/Icons/PurchaseVdoIcon";
import PurchaseRqstIcon from "../../../ui/Icons/PurchaseRqstIcon";
import OpenMsgIcon from "../../../ui/Icons/OpenMsgIcon";
import MenuClearVideoIcon from "../../../ui/Icons/MenuClearVideoIcon";
import TableCalenderIcon from "../../../ui/Icons/TableCalenderIcon";
import useFetch, { usePost } from "../../../hooks/api/useFetch";

const openMessageTableData = [
  {
    vsid: "13194",
    sender: "Jason Marcel",
    senderDesignation: "Manager",
    messageText:
      "Hi there, how are you doing? I was trying to reest my password b...",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "John Smith",
    senderDesignation: "QC Agent",
    messageText:
      "I am curious on when I’ll be paid? Could you please let me kno",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "ViralSnare Admin",
    senderDesignation: "Admin",
    messageText:
      "I am curious on when I’ll be paid? Could you please let me kno",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "Jason Marcel",
    senderDesignation: "Manager",
    messageText:
      "I am curious on when I’ll be paid? Could you please let me kno",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "John Smith",
    senderDesignation: "QC Agent",
    messageText:
      "I am curious on when I’ll be paid? Could you please let me kno",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "ViralSnare Admin",
    senderDesignation: "Admin",
    messageText: "Let’s confirm the shooter of this video",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "Jason Marcel",
    senderDesignation: "Manager",
    messageText:
      "Hi there, how are you doing? I was trying to reest my password b...",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "John Smith",
    senderDesignation: "QC Agent",
    messageText: "Let’s confirm the shooter of this video",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "Jason Marcel",
    senderDesignation: "QC Agent",
    messageText:
      "Hi there, how are you doing? I was trying to reest my password b...",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
  {
    vsid: "13194",
    sender: "Jason Marcel",
    senderDesignation: "QC Agent",
    messageText:
      "Hi there, how are you doing? I was trying to reest my password b...",
    creationDate: "January 16, 2023",
    creationTime: "at 07:53 AM UTC",
  },
];

const listItemLoop = [
  {
    listName: "",
    videoCount: "200",
  },
  {
    listName: "",
    videoCount: "200",
  },
];

const ContentBuyerDashboard = () => {
  const {
    data: buyerSubmissions,
    isLoading,
    isSuccess,
  } = usePost(["buyer-submissions"], "buyer/submissions");
  const {
    data: buyerPurchaseRequests,
    isLoading: buyerPurchaseRequestsIsLoading,
    isSuccess: buyerPurchaseRequestsIsSuccess,
  } = useFetch(["buyer-purchase-requests"], "buyer/purchase/requests");
  console.warn(buyerPurchaseRequests);
  return (
    <UserWrapper footerChatBtn={true} headerPurchaseBtn={true}>
      <Paper elevation={0} className={styles.tabsCard}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          justifyContent={"center"}
          className={styles.tabmenu}
        >
          <Link href="/" className={styles.tabPurchase}>
            <figure>
              <MenuClearVideoIcon />
            </figure>
            <Box className={styles.itemRight}>
              <Typography variant="body1">Purchased Videos</Typography>
              <Typography variant="caption">
                {buyerSubmissions?.data?.data?.submissions?.Purchased_videos
                  ? buyerSubmissions?.data?.data?.submissions?.Purchased_videos
                  : "-"}
              </Typography>
            </Box>
          </Link>
          <Link href="/" className={styles.tabReqst}>
            <figure>
              <PurchaseRqstIcon />
            </figure>
            <Box className={styles.itemRight}>
              <Typography variant="body1">Purchase Requests</Typography>
              <Typography variant="caption">
                {buyerSubmissions?.data?.data?.submissions?.Purchase_requests
                  ? buyerSubmissions?.data?.data?.submissions?.Purchase_requests
                  : "-"}
              </Typography>
            </Box>
          </Link>
          <Link href="/" className={styles.tabMsg}>
            <figure>
              <OpenMsgIcon />
            </figure>
            <Box className={styles.itemRight}>
              <Typography variant="body1">Open Messages</Typography>
              <Typography variant="caption">
                {buyerSubmissions?.data?.data?.submissions?.open_message
                  ? buyerSubmissions?.data?.data?.submissions?.open_message
                  : "-"}
              </Typography>
            </Box>
          </Link>
        </Stack>
      </Paper>
      <Stack
        direction={"row"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
        className={styles.innerSecWrap}
      >
        <Box className="openManagerCol">
          <Paper elevation={0} className="bgPaperCard">
            <Box className="msgBgGradiant">
              <Box className="cardInnerBox">
                <Box className="cardInnerHeading">
                  <Typography variant="h3">
                    Open Messages<span>1200</span>
                  </Typography>
                  <Button endIcon={<NextArrowIcon />} className="btnSeeall">
                    See All
                  </Button>
                </Box>
                <Box className={styles.openMsgTable}>
                  <TableContainer>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className={styles.openMessageTable}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell className={styles.thVsid}>VSID</TableCell>
                          <TableCell className={styles.thSender}>
                            Sender
                          </TableCell>
                          <TableCell className={styles.thMessage}>
                            Message
                          </TableCell>
                          <TableCell className={styles.thCreation}>
                            Creation Date
                          </TableCell>
                          <TableCell align="center" className={styles.thView}>
                            View
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {openMessageTableData.map((row) => (
                          <>
                            <TableRow>
                              <TableCell className={styles.thVsid}>
                                {row?.vsid}
                              </TableCell>
                              <TableCell className={styles.thSender}>
                                <Typography variant="body1">
                                  {row?.sender}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  className={styles.designation}
                                >
                                  {row?.senderDesignation}
                                </Typography>
                              </TableCell>
                              <TableCell className={styles.thMessage}>
                                <Typography
                                  className={styles.messageMaxText}
                                  variant="body1"
                                >
                                  {row?.messageText}
                                </Typography>
                              </TableCell>
                              <TableCell className={styles.thCreation}>
                                <Typography variant="body1">
                                  {row?.creationDate} <br /> {row?.creationTime}
                                </Typography>
                              </TableCell>
                              <TableCell
                                align="center"
                                className={styles.thView}
                              >
                                <Link href="/" className={styles.StyledeyeIcon}>
                                  <img
                                    src={assest.IconView}
                                    width={16}
                                    height={16}
                                    alt="icon"
                                  />
                                </Link>
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                {/* =========== EMPTY ALERT ========= */}
                {/* <Typography variant='body1' className="alertMsg">You have no open messages at the moment.</Typography> */}
              </Box>
            </Box>
          </Paper>
        </Box>
        <Box className="requestUpdateCol">
          <Paper elevation={0} className="bgPaperCard">
            <Box className="purchaseBgGradiant">
              <Box className="requestInnerBox">
                <Box className={`cardInnerHeading ${styles.headingStart}`}>
                  <Typography variant="h3">
                    Purchase Requests Update
                    <span>
                      {buyerPurchaseRequests?.data?.meta?.total
                        ? buyerPurchaseRequests?.data?.meta?.total
                        : "-"}
                    </span>
                  </Typography>
                  <Button className="btnForward">
                    <ForwardIcon />
                  </Button>
                </Box>
                <Box className="videoUrlCardList">
                  <PerfectScrollbar>
                    {buyerPurchaseRequests?.data?.data?.map((item, index) => {
                      return (
                        <VideoUrlCard
                          key={index}
                          videoLink={item?.video_url}
                          noteText={item?.notes}
                          dicision={
                            item?.purchased === item?.status
                              ? "Approved"
                              : "Rejected"
                          }
                          value={item?.purchased === item?.status}
                        />
                      );
                    })}
                  </PerfectScrollbar>
                </Box>
                {/* =========== EMPTY ALERT ========= */}
                {/* <Typography variant='body1' className="alertMsg">You have no updates</Typography> */}
              </Box>
            </Box>
          </Paper>
        </Box>
        <Box className={`${styles.styledSummary} summaryCol`}>
          <Paper elevation={0} className="bgPaperCard">
            <Stack
              direction={"row"}
              alignItems={"flex-start"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              className="showsummaryDate"
            >
              <Box className="summaryDateBox">
                <Typography variant="body1">
                  Showing Data for <span>Today</span>
                </Typography>
                <Typography variant="caption" className="viewDate">
                  (April 22, 2023)
                </Typography>
              </Box>
              <Button className="calenderBtn">
                <TableCalenderIcon />
              </Button>
            </Stack>
            <VideosummaryCard
              videoTitle={"Video Purchase Summary"}
              countVideo={""}
            >
              <List>
                <ListItem>
                  <Typography variant="body1">Purchased videos</Typography>
                  <Typography variant="caption">
                    {buyerSubmissions?.data?.data?.submissions?.Purchased_videos
                      ? buyerSubmissions?.data?.data?.submissions
                          ?.Purchased_videos
                      : "-"}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">
                    Total Purchases Amount
                  </Typography>
                  <Typography variant="caption">
                    {buyerSubmissions?.data?.data?.submissions?.Purchased_videos
                      ? buyerSubmissions?.data?.data?.submissions
                          ?.Purchased_videos
                      : "-"}
                  </Typography>
                </ListItem>
              </List>
            </VideosummaryCard>
          </Paper>
        </Box>
      </Stack>
    </UserWrapper>
  );
};

export default ContentBuyerDashboard;
